


























import { Component, Mixins, Prop } from "vue-property-decorator";
import { LineStyle, Color, LineKinds, PaintStyle, TextureKinds, TextStyle, TextAlignKinds } from "../../../../../../base/domain/drawing";
import { TextBoxDragHandles } from "../../../../../../base/components/dragging";
import { ObjectKeys } from "../../../../../domain/configuration";
import { RectangleCoordinatableObjectDrawerBase } from "./base";
import { ConfiguredTextAreaEditor } from "./drawers";
import { TextPropertyEditableMixin } from "../../mixins";
import { ObjectUpdatesPromptableMixin } from "../trackers/mixins";

@Component({
  components: {
    ConfiguredTextAreaEditor,
    TextBoxDragHandles,
  },
})
export default class TextAreaRectangleCoordinatableObjectEditor extends Mixins(RectangleCoordinatableObjectDrawerBase, TextPropertyEditableMixin, ObjectUpdatesPromptableMixin) {
  @Prop({ default: false })
  readonly: boolean;

  @Prop()
  configurationKey: ObjectKeys;

  @Prop({ default: () => new TextStyle(new Color("#ff0000"), TextAlignKinds.MiddleCenter, 8) })
  textStyle: TextStyle;

  @Prop({ default: () => new PaintStyle(new Color("#ffff00"), TextureKinds.Fill) })
  paintStyle: PaintStyle;

  @Prop({ default: () => new LineStyle(new Color("#ff0000"), LineKinds.Normal, 1) })
  borderStyle: LineStyle;

  onMouseDowned(event: PointerEvent) {
    const currentPage = this.getCommonComponents().getOperators().getCurrentPage();
    if (this.isSelected) {
      return;
    }
    this.promptForObjectUpdates(event);
    this.$nextTick(() => {
      if (!event.ctrlKey) {
        currentPage.reselectObjects(this.editingSource);
      } else {
        currentPage.selectObjects(this.editingSource);
      }
    });
  }
}
